export enum RoutePathsE {
  TICKETS_PAGE = '/tickets',
  TICKET_DETAIL = '/tickets/ticket',
  LOGIN_PAGE = '/login',
  PROFILE_PAGE = '/profile',
  WIP = '/wip',
}
